export default __webpack_public_path__ + "static/media/get-app.101c385a.svg";